import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { Subject } from '../../../../models'

@Component({
  selector: 'app-search-box-com',
  templateUrl: './search-box.com.html'
})

export class SearchBoxComponent implements OnInit {

  typing = new Subject<string>()
  @Output() words = new EventEmitter<string>()

  ngOnInit() {
    this.listenToSearch()
    this.words.emit(null)
  }

  public listenToSearch() {
    this.typing.debounceTime(400).distinctUntilChanged().subscribe(words => this.words.emit(words))
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/forms/search-box/search-box.com.ts